
















































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";

class PageShowquestionOfPapersRequest extends PageRequest {
  questionId: string;
}

@Component({})
export default class ShowquestionOfPapers extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  //filters
  pagerequest: PageShowquestionOfPapersRequest =
    new PageShowquestionOfPapersRequest();
  screenWidth: number = document.body.clientWidth - 200;

  cancel() {
    this.visibleChange(false);
  }
  searchGetpage() {
    this.$store.state.questionOfPapers.currentPage = 1;
    this.getpage();
  }
  handleRefresh() {
    this.getpage();
  }
  get list() {
    return this.$store.state.questionOfPapers.list;
  }
  get loading() {
    return this.$store.state.questionOfPapers.loading;
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.pagerequest.questionId =
        this.$store.state.testQuestion.editTestQuestion.id;
      this.getpage();
    }
  }
  pageChange(page: number) {
    this.$store.commit("questionOfPapers/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("questionOfPapers/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "questionOfPapers/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.questionOfPapers.pageSize;
  }
  get totalCount() {
    return this.$store.state.questionOfPapers.totalCount;
  }
  get currentPage() {
    return this.$store.state.questionOfPapers.currentPage;
  }

  columns = [
    {
      title: "试卷名称",
      key: "name",
      render: (h, params) => {
        return h("span", [
          h(
            "A",
            {
              attrs: {
                target: "_blank",
                title: params.row.name,
                href: "http://www.sxjy.cq.cn/testpaper/" + params.row.id,
              },
              props: {
                type: "info",
                size: "small",
              },
              style: { "font-size": "12px", color: "#2c3e50" },
            },
            params.row.name
          ),
        ]);
      },
    },
    {
      title: "K币",
      width: 70,
      key: "money",
    },
    {
      title: "试题数",
      width: 80,
      key: "totalQuestion",
    },
    {
      title: "考试",
      width: 80,
      key: "numberOfExams",
    },

    {
      title: "激活",
      width: 70,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              color: params.row.isActive ? "" : "red",
            },
          },
          params.row.isActive ? "是" : "否"
        );
      },
    },
    {
      title: "状态",
      width: 80,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              color: params.row.isAudited ? "" : "red",
            },
          },
          params.row.isAudited ? "已审" : "审核"
        );
      },
    },
    {
      title: "发布时间",
      key: "createionDay",
      width: 100,
      render: (h: any, params: any) => {
        return h(
          "span",
          new Date(params.row.createionDay).toLocaleDateString()
        );
      },
    },
    {
      title: "发布人",
      key: "creatorUserName",
      width: 80,
    },
  ];
  async created() {
    this.visibleChange(true);
  }
}
